import { type ApiHandlerContract, ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { DeepLink, TeamApiResponse, TeamRoleApiResponse } from '../types';

export interface TeamApiContract {
  get(): Promise<TeamApiResponse>;
  invite(payload: { email: string; role: TeamRoleApiResponse }): Promise<void>;
  removeMember(userId: number): Promise<void>;
  deleteInvite(inviteId: number): Promise<void>;
  swapOwner(userId: number): Promise<void>;
  selectPlanURL(): Promise<string>;
  getDeepLinks(): Promise<DeepLink[]>;
}

export class TeamApi extends ApiService implements TeamApiContract {
  constructor(
    api: ApiHandlerContract,
    private teamId: number,
  ) {
    super(api);
  }

  public get(): Promise<TeamApiResponse> {
    return this.api.fetch<TeamApiResponse>({
      method: 'GET',
      path: `/teams/${this.teamId}`,
    });
  }

  public async invite(payload: { email: string; role: TeamRoleApiResponse }): Promise<void> {
    await this.api.fetch<void>({
      method: 'POST',
      path: `/teams/${this.teamId}/invite`,
      payload,
    });
  }

  public async removeMember(userId: number): Promise<void> {
    await this.api.fetch<void>({
      method: 'DELETE',
      path: `/teams/${this.teamId}/members/${userId}`,
    });
  }

  public async deleteInvite(inviteId: number): Promise<void> {
    await this.api.fetch<void>({
      method: 'DELETE',
      path: `/team-invitations/${inviteId}`,
    });
  }

  public async swapOwner(userId: number): Promise<void> {
    await this.api.fetch<void>({
      method: 'POST',
      path: `/teams/${this.teamId}/swap-owner/${userId}`,
    });
  }

  public async selectPlanURL(): Promise<string> {
    return await this.api.fetch<string>({
      method: 'POST',
      path: `/teams/${this.teamId}/billing/select-plan-url`,
    });
  }

  public async getDeepLinks(): Promise<DeepLink[]> {
    return await this.api.fetch<DeepLink[]>({
      method: 'GET',
      path: `/teams/${this.teamId}/billing/deep-links`,
    });
  }
}
